import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Field, reduxForm, getFormValues, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';

import { createPatientVitals } from 'redux/modules/patientsVitals';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  caption: {
    color: theme.palette.grey[600],
    fontSize: pxToRem(12),
    fontWeight: '700',
    marginTop: 6,
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
    lineHeight: pxToEm(12, 12),
    letterSpacing: pxToEm(0.5, 12),
  },
  value: {
    height: 34,
    color: theme.palette.secondary[650],
    fontSize: pxToRem(20),
    fontWeight: '500',
    lineHeight: '34px',
    letterSpacing: pxToEm(0.5, 20),
  },
  label: {
    fontSize: pxToRem(12),
    fontWeight: '700',
    color: theme.palette.secondary[650],
    marginTop: 25,
  },
});

function onSubmit(values, dispatch, props) {
  return new Promise((resolve, reject) => {
    dispatch(createPatientVitals({
      values: {
        'User Record Number': props['Record Number'],
        Weight: Number(values.Weight),
        ...values['Height Ft'] ? {
          'Height Ft': Number(values['Height Ft']),
          ...!values['Height In'] ? { 'Height In': 0 } : {
            'Height In': Number(values['Height In']),
          },
        } : {
          'Height Ft': Math.floor(values['Height In'] / 12),
          'Height In': values['Height In'] % 12,
        },
      },
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      throw new SubmissionError(err);
    });
}

function validateForm(values) {
  const errors = {};

  if (!values['Height Ft'] && !values['Height In']) {
    errors['Height Ft'] = 'Height is required';
    errors['Height In'] = 'Height is required';
  }

  return errors;
}

const VitalsCreateForm = (props) => {
  let bmi;
  if (props.valid && (props['Height Ft'] || props['Height In'])) {
    const weight = Number(props.Weight) * 703;
    const height = props['Height Ft']
      ? (Number(props['Height Ft']) * 12) + Number(props['Height In'])
      : Number(props['Height In']);
    bmi = (weight / (height * height)).toFixed(1);
  }

  return (
    <form
      noValidate
      autoComplete="off"
      onSubmit={props.handleSubmit}
      className={props.className}
    >
      <Grid container justify="center" spacing={8}>
        <Grid item xs={3}>
          <Field
            id="Weight"
            name="Weight"
            label="Weight"
            component={TextField}
            validate={[validate.required]}
            normalize={normalize.number}
            maxLength="3"
            fullWidth
          />
        </Grid>
        <Grid item xs={1} alignItems="center" container spacing={0}>
          <Typography className={props.classes.label}>
            lbs
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Field
            id="Height Ft"
            name="Height Ft"
            label="Height"
            component={TextField}
            normalize={normalize.number}
            maxLength="2"
            fullWidth
          />
        </Grid>
        <Grid item xs={1} alignItems="center" container spacing={0}>
          <Typography className={props.classes.label}>
            ft
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Field
            id="Height In"
            name="Height In"
            label="Height"
            hideLabel
            component={TextField}
            normalize={normalize.number}
            maxLength="2"
            fullWidth
          />
        </Grid>
        <Grid item xs={1} sm={2} alignItems="center" container spacing={0}>
          <Typography className={props.classes.label}>
            in
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Fragment>
            <Typography className={props.classes.caption}>
              BMI
            </Typography>
            <Typography className={props.classes.value}>
              {!Number.isNaN(Number(bmi)) ? bmi : '0.0'}
            </Typography>
          </Fragment>
        </Grid>
      </Grid>
    </form>
  );
};

VitalsCreateForm.propTypes = {
  Weight: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  'Height Ft': PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  'Height In': PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  valid: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({
    caption: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
};

VitalsCreateForm.defaultProps = {
  Weight: null,
  'Height Ft': null,
  'Height In': null,
  valid: false,
  className: '',
};

const mapStateToProps = (store, ownProps) => {
  const formValues = getFormValues(ownProps.form)(store);
  return {
    Weight: formValues && formValues.Weight
      ? formValues.Weight : null,
    'Height Ft': formValues && formValues['Height Ft']
      ? formValues['Height Ft'] : null,
    'Height In': formValues && formValues['Height In']
      ? formValues['Height In'] : null,
  };
};

export default connect(mapStateToProps)(reduxForm({
  onSubmit,
  validate: validateForm,
})(withStyles(styles)(VitalsCreateForm)));



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Vitals/VitalsCreateForm.js